import { config } from '@/config';

export const addLocaleToUrl = (locale: string, path: string, asPath?: string) => {
    const localePrefix = config.locales.find((locale) => path?.startsWith(`/${locale}`));
    const currentPath = asPath || path;
    return localePrefix ? currentPath.replace(localePrefix, locale) : `/${locale}${currentPath}`;
};
